// services/support/auditLogService.ts
import axios from "axios";
import { AuditLogSearchResponse } from "../../types/features/support/AuditLog";
import { MAIN_API_URL } from "../../config/api";

export const auditLogService = {
  async searchByEmail(
    email: string,
    page: number = 1,
    size: number = 50,
    filters?: { method?: string; from_date?: string; to_date?: string }
  ): Promise<AuditLogSearchResponse> {
    const response = await axios.get<AuditLogSearchResponse>(`${MAIN_API_URL}/audit-logs/search`, {
      params: {
        email,
        page,
        size,
        ...filters,
      },
    });
    return response.data;
  },
};
